import {Regions} from "./../model/Region"
import {UniversityBranches} from "./../model/UniversityBranch"
import {Specialities} from "./../model/Speciality"

import {SheetData} from "./../Excel/export"
import {
    RowData,
    getCompany,
//    getUniversityBranch,
    getSpeciality,
    getRegion,
} from "./../model/utils/utils"
import {Demand, DemandList} from "../model/Demand";
import {Divisions} from "../model/Division";
import {User} from "../model/User";
import {
    specialityColumns, Columns, entranceColumns, universityColumns, specialityMerges, Rows,
    universityMerges, border, makeSheet, makeEmptyRow, makeSpecialityData, makeUniversityData, demandColumnToYear
} from "./common";

const columnsOrder = [
    ...specialityColumns,
    Columns.isOpk,
    ...entranceColumns,
    Columns.employmentRegion,
    ...universityColumns,
]

type Data = {
    demand: DemandList
    divisions: Divisions
    regions: Regions
    specialities: Specialities
    universityBranches: UniversityBranches
    meta: {
        company: string
        user: User
    }
}

const composeData = ({
    demand,
    divisions,
    regions,
    specialities,
    universityBranches,
}: Data): RowData[] => {
    let rawResult: RowData[] = []

    demand.map(({
        id,
        companyId,
        courseOfStudyName,
        specialityId,
        regionId,
        universityBranchId,
        targetRequestTotal,
        targetRequestByYear,
        nationalProjectName,
        englishLevelName,
        languageName,
        addBachelorTarget,
        employmentRegionId,
    }: Demand) => {
        if (!targetRequestTotal) {
            return
        }

        const {
            bachelorSpecialityId,
        } = getSpeciality(specialities, specialityId)

        const {
            isOpk,
        } = getCompany(divisions, companyId)

        const {
            name: employmentRegionName,
        } = getRegion(regions, employmentRegionId)

/*
        const {
            specialitiesOpk,
        } = getUniversityBranch(universityBranches, universityBranchId)
*/

        if (entranceColumns.some(column => !!targetRequestByYear[demandColumnToYear[column]])) {
            const row = makeEmptyRow(columnsOrder, {
                ...makeSpecialityData({
                    id,
                    courseOfStudyName,
                    divisions,
                    companyId,
                    specialities,
                    specialityId,
                    nationalProjectName,
                    englishLevelName,
                    languageName,
                }),
                ...makeUniversityData({
                    regions,
                    regionId,
                    universityBranches,
                    universityBranchId,
                }),
                [Columns.isOpk]: (isOpk/* && specialitiesOpk.has(specialityId)*/) ? "Да" : "Нет",
                [Columns.employmentRegion]: employmentRegionName,
                ...entranceColumns.reduce((row, column) => ({...row, [column]: targetRequestByYear[demandColumnToYear[column]] || ""}), {}),
            })

            rawResult = rawResult.concat([row])
        }

        if (addBachelorTarget && bachelorSpecialityId) {
            if (entranceColumns.some(column => !!targetRequestByYear[demandColumnToYear[column] + 4])) {
                const row = makeEmptyRow(columnsOrder, {
                    ...makeSpecialityData({
                        id: id + "." + specialityId,
                        courseOfStudyName,
                        divisions,
                        companyId,
                        specialities,
                        specialityId: bachelorSpecialityId,
                        nationalProjectName,
                        englishLevelName,
                        languageName,
                    }),
                    ...makeUniversityData({
                        regions,
                        regionId,
                        universityBranches,
                        universityBranchId,
                    }),
                    [Columns.isOpk]: (isOpk/* && specialitiesOpk.has(specialityId)*/) ? "Да" : "Нет",
                    [Columns.employmentRegion]: employmentRegionName,
                    ...entranceColumns.reduce((row, column) => ({...row, [column]: targetRequestByYear[demandColumnToYear[column] + 4] || ""}), {}),
                })

                rawResult = rawResult.concat([row])
            }
        }
    })

    return rawResult
}

export const targetRequestWs = (data: Data): SheetData => makeSheet({
    sheetTitle: "Заявка по целевикам ",
    title1: "Заявка Государственной корпорации по атомной энергии «Росатом» на подготовку кадров",
    title2: "с высшим и средним профессиональным образованием по программе целевого обучения.",
    company: data.meta.company,
    fullName: data.meta.user.executor.fullName,
    columnsOrder,
    heading1Row: {
        [entranceColumns[0]]: {s: {border}},
        [Columns.employmentRegion]:       {s: {border, font: {bold: true}, alignment: {wrapText: true, horizontal: "center", vertical: "center"}}, v: "Регион трудоустройства"},
    },
    merges: [
        ...specialityMerges,

        [Columns.isOpk, Rows.Heading1, Columns.isOpk, Rows.Heading3],
        [Columns.employmentRegion,     Rows.Heading1, Columns.employmentRegion,     Rows.Heading3],

        [entranceColumns[0], Rows.Heading1, entranceColumns[entranceColumns.length - 1], Rows.Heading2],

        ...universityMerges,
    ],
    data: composeData(data),
    specialities: data.specialities,
})
